import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { reportService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';
import { ReconcileSystemUnitsReportRequest } from '../../../types/report';

export const fetchPortfolioOrderExecutionReport = createAsyncThunk(
  'report/fetch-portfolio-order-execution',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchPortfolioOrderExecutionReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchCashReport = createAsyncThunk('report/fetch-cash', (data: PaginatedRequest, { rejectWithValue }) =>
  reportService.fetchCashReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchCashTransactionsReport = createAsyncThunk(
  'report/fetch-cash-transactions',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchCashTransactionsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchUsersReport = createAsyncThunk('report/fetch-users', (data: PaginatedRequest, { rejectWithValue }) =>
  reportService.fetchUsersReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchOrdersReport = createAsyncThunk(
  'report/fetch-orders',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchOrdersReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchAumReport = createAsyncThunk('report/fetch-aum', (data: PaginatedRequest, { rejectWithValue }) =>
  reportService.fetchAumReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchAccumulatedAumReport = createAsyncThunk(
  'report/fetch-accumulated-aum',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchAccumulatedAumReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchPortfolioDetailsReport = createAsyncThunk(
  'report/fetch-portfolio-details',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchPortfolioDetailsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchPortfolioTotalsReport = createAsyncThunk(
  'report/fetch-portfolio-totals',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchPortfolioTotalsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchSystemCashReport = createAsyncThunk(
  'report/fetch-system-cash',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchSystemCashReport(data).catch((error) => rejectWithValue(error)),
);

export const reconcileSystemCashReport = createAsyncThunk(
  'report/reconcile-system-units',
  (data: ReconcileSystemUnitsReportRequest, { rejectWithValue }) =>
    reportService.reconcileSystemUnitsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchUnitsReport = createAsyncThunk('report/fetch-units', (data: PaginatedRequest, { rejectWithValue }) =>
  reportService.fetchUnitsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchSystemUnitsReport = createAsyncThunk('report/fetch-system-units', () =>
  reportService.fetchSystemUnitsReport(),
);

export const fetchFxRevenueAlpacaOrdersReport = createAsyncThunk(
  'report/fx-revenue-alpaca-orders',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchFxRevenueAlpacaOrdersReport(data).catch(rejectWithValue),
);

export const fetchFxRevenueAlpacaTransfersReport = createAsyncThunk(
  'report/fx-revenue-alpaca-transfers',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchFxRevenueAlpacaTransfersReport(data).catch(rejectWithValue),
);

export const fetchFxRevenueJadwaOrdersReport = createAsyncThunk(
  'report/fx-revenue-jadwa-orders',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchFxRevenueJadwaOrdersReport(data).catch(rejectWithValue),
);

export const fetchFxRevenueJadwaTransfersReport = createAsyncThunk(
  'report/fx-revenue-jadwa-transfers',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchFxRevenueJadwaTransfersReport(data).catch(rejectWithValue),
);

export const fetchUserIndexFundReport = createAsyncThunk(
  'report/user-index-fund',
  (
    data: PaginatedRequest & {
      startDate?: string;
      endDate?: string;
      groupByUser: boolean;
    },
    { rejectWithValue },
  ) => reportService.fetchUserIndexFundReport(data).catch(rejectWithValue),
);

export const fetchAlpacaJournalReport = createAsyncThunk(
  'report/alpaca-journal',
  (data: PaginatedRequest, { rejectWithValue }) => reportService.fetchAlpacaJournalReport(data).catch(rejectWithValue),
);

export const fetchCmaUsersReport = createAsyncThunk(
  'report/fetch-cma-users',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchCmaUsersReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchUserDetailsReport = createAsyncThunk(
  'report/fetch-user-details',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchUserDetailsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchFeeCalculationsReport = createAsyncThunk(
  'report/fetch-fee-calculations',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchFeeCalculationsReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchFinanceUsersReport = createAsyncThunk(
  'report/fetch-finance-users',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchFinanceUsersReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchPortfolioCompositionReport = createAsyncThunk(
  'report/fetch-portfolio-composition',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchPortfolioCompositionReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchPortfolioSnapshotReport = createAsyncThunk(
  'report/fetch-portfolio-snapshot',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchPortfolioSnapshotReport(data).catch((error) => rejectWithValue(error)),
);

export const fetchPortfolioOrdersDataReport = createAsyncThunk(
  'report/fetch-portfolio-orders-data',
  (data: PaginatedRequest, { rejectWithValue }) =>
    reportService.fetchPortfolioOrdersDataReport(data).catch((error) => rejectWithValue(error)),
);

export const cleanReport = createAction('report/clean');
